import { ProductType } from '@inter-ikea-storageone/range';
import { getQPPImage } from 'products';
import { ProductListConfig } from 'rangeConfig/@types';
import addTopPanelToFrame from 'rangeConfig/besta/behaviors/addTopPanelToFrame';
import autoFillTopPanels from 'rangeConfig/besta/behaviors/autoFillTopPanels';
import removeTopPanelsInScene from 'rangeConfig/besta/behaviors/removeTopPanelsInScene';
import { matchTopPanelsToFramesInScene } from 'rangeConfig/besta/filters/mainMenuProductFilters';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';

export const topPanelProductListConfig: ProductListConfig = {
  cardsSubtitle: 'typeName, designText',
  behaviors: {
    productClicked: [autoFillTopPanels],
    productDropped: [addTopPanelToFrame]
  },
  productCardMainImage: getQPPImage,
  cluster: ['design'],
  productFilters: [matchTopPanelsToFramesInScene],
  sortOrder: [{ path: 'designText', reverse: true }],
  categories: [
    {
      id: 'top-panel',
      products: [
        { path: 'type', value: ProductType.BESTA_TOP_PANEL },
        { path: 'type', value: ProductType.BESTA_TOP_PANEL_TV_BENCH }
      ]
    }
  ],
  noneOption: {
    title: 'storageone.productListNoTopPanelsOptionTitle',
    behaviors: { removeProducts: [removeTopPanelsInScene] },
    selected: noProductsWithTypesInScene([
      ProductType.BESTA_TOP_PANEL,
      ProductType.BESTA_TOP_PANEL_TV_BENCH
    ])
  }
};
